

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// markNotificationAsReadForUser
// MARKNOTIFICATIONASREADFORUSER   
const MARKNOTIFICATIONASREADFORUSER= createAsyncThunk(
  "markNotificationAsReadForUser/markNotificationAsReadForUser",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const markNotificationAsReadForUserSlice = createSlice({
  name: "markNotificationAsReadForUserSlice",
  initialState: {
    markNotificationAsReadForUser: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfmarkNotificationAsReadForUser: (state) => {
        state.markNotificationAsReadForUser.loading = false
        state.markNotificationAsReadForUser.error = false
        state.markNotificationAsReadForUser.data = []
        state.markNotificationAsReadForUser.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(MARKNOTIFICATIONASREADFORUSER.fulfilled, (state, action) => {
      state.markNotificationAsReadForUser = {
        ...state.markNotificationAsReadForUser,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MARKNOTIFICATIONASREADFORUSER.pending, (state, action) => {
      state.markNotificationAsReadForUser = {
        ...state.markNotificationAsReadForUser,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MARKNOTIFICATIONASREADFORUSER.rejected, (state, action) => {
      state.markNotificationAsReadForUser = {
        ...state.markNotificationAsReadForUser,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const markNotificationAsReadForUserAction = {
    MARKNOTIFICATIONASREADFORUSER,
};

export { markNotificationAsReadForUserAction };
export default markNotificationAsReadForUserSlice.reducer;
export const {setInitialStateOfmarkNotificationAsReadForUser} = markNotificationAsReadForUserSlice.actions